import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { PrintBookingsSheetBase } from './PrintBookingsSheet'

import { dataSelector } from 'reduxModules/selectors/ModalSelectors'

const mapStateToProps = createStructuredSelector({
  data: dataSelector
})

export const PrintBookingsSheet = connect(mapStateToProps)(PrintBookingsSheetBase)


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PrintBookingsSheet/index.js